'use client';
var classes = {"root":"m-f61ca620","input":"m-ccf8da4c","innerInput":"m-f2d85dd2","visibilityToggle":"m-b1072d44"};

export { classes as default };
//# sourceMappingURL=PasswordInput.module.css.mjs.map
